import { ModalContext } from "./context";
import React, { useContext } from "react";
import { StyleSheet, TouchableOpacity } from "react-native";
import { useThemedStyle, StyleFunction } from "../../theme";

/**
 * Where the modals are rendered
 */
export function ModalContainer() {
    const styles = useThemedStyle(styleFunc);
    const ctx = useContext(ModalContext);
    if (!ctx) {
        return null;
    }

    const { stack } = ctx;

    return (
        <>
            {stack.map(modal => (
                <TouchableOpacity
                    onPress={() => {
                        if (!modal.closeOnOutside) {
                            return;
                        }
                        modal.resolve();
                    }}
                    key={modal.id}
                    style={[StyleSheet.absoluteFill, styles.modalContainer]}
                    activeOpacity={1}
                >
                    {modal.renderContent(modal.resolve)}
                </TouchableOpacity>
            ))}
        </>
    );
}

const styleFunc: StyleFunction = theme => ({
    modalContainer: {
        flex: 1,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.colors.semiTransparentBackground,
    },
});
